import React from "react";
import { Navigate } from "react-router-dom";

export default function Home(): JSX.Element {
	return (
		<div className="home-container">
			{/* Not sure if there's going to be a homepage or not here, just redirect to /admin for now */}
			<Navigate to={"/admin"} replace />
		</div>
	);
}
